import { render, staticRenderFns } from "./SetLabels.vue?vue&type=template&id=2c48d136&scoped=true&"
import script from "./SetLabels.vue?vue&type=script&lang=js&"
export * from "./SetLabels.vue?vue&type=script&lang=js&"
import style0 from "./SetLabels.vue?vue&type=style&index=0&id=2c48d136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48d136",
  null
  
)

export default component.exports